module.exports = __webpack_public_path__ + "img/whpca.f20ffe27.png";